import Footer1 from "../Layout/Footer/Footer1";
import NavbarTransparent from "../Layout/Navbar/NavbarTransparent";
import Banner from "./Banner";
import PoplarAttractions from "./PoplarAttractions";
import Downtab from "../Downtab";

const Home = () => {

  return (
    <div className="relative w-full" style={{ backgroundColor: "#EDE8E0", minHeight: "100vh" }}>
      <NavbarTransparent />
      <Banner />

      {/* Below-fold */}
      {/* Bottom padding on mobile keeps the footer clear of the fixed Downtab */}
      <div className="pb-[76px] md:pb-0" style={{ backgroundColor: "#EDE8E0" }}>
        <PoplarAttractions />
        <Footer1 />
      </div>

      <Downtab />
    </div>
  );
};

export default Home;
